import { RideStatusDescription, RideStatusType } from './rideStatusType';

export enum RideAttentionStatus {
  DriverNotAssigned = 34,
  DoubleBooked = 35,
  declined = 36,
  none = 37,
  MonitorDoubleBooked = 103,
  DriverMonitorDoubleBooked = 104,
  DriverNotAssignedMonitorDoubleBooked = 105,
}

export const RideAttentionStatusDescription = (key: number, rideJobStatus: RideStatusType, isClient: boolean = false) => {
  switch (key) {
    case RideAttentionStatus.declined:
      return 'Declined';
    case RideAttentionStatus.DoubleBooked:
    case RideAttentionStatus.DriverMonitorDoubleBooked:
    case RideAttentionStatus.MonitorDoubleBooked:
    case RideAttentionStatus.DriverNotAssignedMonitorDoubleBooked:
      if (isClient) {
        return RideStatusDescription(rideJobStatus) == 'none' ? 'Scheduled' : RideStatusDescription(rideJobStatus);
      } else {
        switch (key) {
          case RideAttentionStatus.DoubleBooked:
            return 'Driver 2X Booked';
          case RideAttentionStatus.DriverMonitorDoubleBooked:
            return 'Driver & Monitor 2X Booked';
          case RideAttentionStatus.MonitorDoubleBooked:
            return 'Monitor 2X Booked';
          case RideAttentionStatus.DriverNotAssignedMonitorDoubleBooked:
            return 'Monitor 2X Booked';
          default:
            return RideStatusDescription(rideJobStatus) == 'none' ? 'Scheduled' : RideStatusDescription(rideJobStatus);
        }
      }
    case RideAttentionStatus.DriverNotAssigned:
      return 'Driver not Assigned';
    default:
      return 'N/A';
  }
};
